module.exports = __webpack_public_path__ + "static/media/dinner.319ce9f7.svg";